import React from 'react';
import classnames from 'classnames/bind';
import { get } from 'lodash';

import styles from './ideaViewStyles';

import IdeaViewSummary from './IdeaViewSummary/ideaViewSummary';
import Link, { LINK_TYPES } from 'buyside/components/presentation/Link/link';
import Icon from 'buyside/components/presentation/Icon/icon';
import ViewerIntroRequestButton from 'buyside/components/presentation/IdeaViewsPage/ViewerIntroRequestButton/viewerIntroRequestButton';

import EyeIcon from 'buyside/svgs/eye.svg';
import StarIcon from 'buyside/svgs/star.svg';
import DownArrowIcon from 'buyside/svgs/down_arrow.svg';
import MessageBubbleIcon from 'buyside/svgs/message_bubble.svg';

import { contributorDashboardIdeasUrl } from 'buyside/util/urlHelper';

const cx = classnames.bind(styles);

const IdeaView = ({
  view,
  showIntroRequest,
  fullText = true,
  isBig = false,
  isLink = false,
  introRequestDisabled = null
}) => {
  const iconMap = {
    'Rated Idea': StarIcon,
    'Commented on Idea': MessageBubbleIcon,
    'Downloaded Supporting Document': DownArrowIcon,
    'Downloaded PDF of Idea': DownArrowIcon
  };

  const viewerCanReceiveIntroRequest =
    showIntroRequest &&
    view.viewer.canReceiveViewerIntroRequest &&
    !get(view, 'viewer.emailPreferences', []).some(
      ({ emailType, subscribed }) => emailType === 'viewerIntroRequest' && !subscribed
    );

  const summary = (
    <IdeaViewSummary
      view={view}
      fullText={fullText}
      isBig={isBig}
      viewerCanReceiveIntroRequest={viewerCanReceiveIntroRequest}
    />
  );

  return (
    <div className={cx({ outerViewContainer: true, isBig })}>
      <div className={cx({ viewContainer: true, isBig })}>
        <EyeIcon className={cx({ viewIcon: true, isBig })} />
        <div className={cx({ viewInfo: true, isBig })}>
          {isLink ? (
            <Link to={contributorDashboardIdeasUrl(view.ideaId)} type={LINK_TYPES.PLAIN}>
              {summary}
            </Link>
          ) : (
            summary
          )}
          {!!view.actions.length && (
            <ul className={cx({ viewActions: true, isBig })}>
              {view.actions.map((action, idx) => {
                return (
                  <li key={idx}>
                    <Icon type={iconMap[action]} className={cx({ actionIcon: true, isBig })} />
                    Has {action}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      <div className={styles.rowRight}>
        {viewerCanReceiveIntroRequest ? (
          <ViewerIntroRequestButton
            id={get(view, 'viewerIntroRequest.id')}
            status={get(view, 'viewerIntroRequest.status', 'unsent')}
            viewId={view.id}
            viewableId={view.ideaId}
            viewableType="Idea"
            viewerId={view.viewer.id}
          />
        ) : (
          <>{introRequestDisabled}</>
        )}
        <div className={cx({ viewTime: true, isBig })}>{view.timeAgo} ago</div>
      </div>
    </div>
  );
};

export default IdeaView;
